import '../../../styles/pages.css'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from '@mui/material'
import React from 'react'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import DeleteResourceButton from '../shared/DeleteResourceButton'
import DistrictFeatures from './district_features/DistrictFeatures'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SAMLForm from '../shared/SAMLForm'
import UpdateDistrictForm from './UpdateDistrictForm'
import DistrictHeader from './DistrictHeader'
import DataRemovalButton from '../shared/DataRemovalButton'
import {
  useDistrictIngestionResource,
  useDistrictResource,
} from '../../../api/district.hooks'
import AddLTIConfiguration from './AddLTIConfiguration'
import SISDistrictForm from './SISDistrictForm'

export function DistrictEdit({ id }: { id: string }) {
  const { data } = useDistrictResource(id)
  const { data: ingestedDistrict } = useDistrictIngestionResource(id)

  if (!data) {
    return <div>Loading...</div>
  }
  return (
    <div className="content-color">
      <DistrictHeader district={data} ingestedDistrict={ingestedDistrict} />
      <hr />
      <DataRemovalButton districtID={data.id} />
      <hr />
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Update district info
        </AccordionSummary>
        <AccordionDetails>
          <UpdateDistrictForm districtID={data.id} />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          District Rostering Info
        </AccordionSummary>
        <AccordionDetails>
          <SISDistrictForm districtID={parseInt(data.id)} />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Update LTI Integration
          <Tooltip
            title="
          Information coming soon"
          >
            <QuestionMarkIcon
              sx={{ height: '12px', width: '12px', marginTop: '-3px' }}
            />
          </Tooltip>
        </AccordionSummary>
        <AccordionDetails>
          <AddLTIConfiguration districtID={parseInt(data.id)} />
        </AccordionDetails>
      </Accordion>
      <DistrictFeatures />
      <SAMLForm districtID={Number(data.id)} schoolID={-1} />
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Delete District
        </AccordionSummary>
        <AccordionDetails>
          <DeleteResourceButton
            name={data.name}
            resource="District"
            districtID={parseInt(data.id)}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
